
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'RcsWelcomeStep',

  setup() {
    const { t } = useI18n();
    const benefitKeys = [
      'storeParameters.services.rcsServiceParameter.welcome.benefit1',
      'storeParameters.services.rcsServiceParameter.welcome.benefit2',
      'storeParameters.services.rcsServiceParameter.welcome.benefit3',
      'storeParameters.services.rcsServiceParameter.welcome.benefit4',
    ];
    return { t, benefitKeys };
  },
});
